import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import axios from "axios";
import { useParams, useNavigate, Link } from "react-router-dom";
import { uploadAWS } from "../../common/AWSHelper";
import { Field, Form, Formik } from "formik";
import { toastError, toastSuccess } from "../../common/Toast";
import {
  ALREADY_EXIST,
  AWS_IMAGE_FOLDER_SUPPLIERS,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  NECESSARY_FIELD,
  ALL_NECESSARY_FIELD,
} from "../../common/Constant";
import FileInput from "../FormControls/FileInput";
import Select from "react-select";
import config from "../../config/config";
import ManageSuppliers from "../../pages/MainPages/Suppliers/ManageSuppliers";

function SupplierFormData(props) {
  const [formValues, setFormValues] = useState({
    CompanyName: "",
    Title: "",
    FirstName: "",
    LastName: "",
    EMail: "",
    PhoneNumber: "",
    SelectImage: "",
    Address1: "",
    Address2: "",
    City: "",
    StateProvince: "",
    Zip: "",
    Country: "",
    Comments: "",
    InternalNotes: "",
    Account: "",
    Terms: "",
    Openingbalance: "",
    Balance: "",
    OverrideDefaultTaxForSale: false,
    TaxGroup: "",
    TaxId1: 0,
    TaxName1: "",
    TaxPercent1: "",
    TaxId2: 0,
    TaxName2: "",
    TaxPercent2: "",
    Cumulative: false,
    TaxId3: 0,
    TaxName3: "",
    TaxPercent3: "",
    TaxId4: 0,
    TaxName4: "",
    TaxPercent4: "",
    TaxId5: 0,
    TaxName5: "",
    TaxPercent5: "",
    FileId1: 0,
    File1: "",
    FileId2: 0,
    File2: "",
    FileId3: 0,
    File3: "",
    FileId4: 0,
    File4: "",
    FileId5: 0,
    File5: "",
  });
  const [File1Url, setFile1Url] = useState("");
  const [File2Url, setFile2Url] = useState("");
  const [File3Url, setFile3Url] = useState("");
  const [File4Url, setFile4Url] = useState("");
  const [File5Url, setFile5Url] = useState("");
  const [showMore, setShowMore] = useState(false);
  const [btnLoader, setBtnLoader] = useState({ SelectImage: false });
  const [loading, setLoading] = useState(false);
  const [disableCumulative, setDisableCumulative] = useState(false);
  const [changeImagename, setChangeImagename] = useState(false);
  const [ImageUrl, setImageUrl] = useState("");
  const [customFieldSupplierValues, setCustomFieldSupplierValues] = useState(
    []
  );
  const [customFileUrl, setCustomFileUrl] = useState("");
  const [selectTaxable, setSelectTaxable] = useState(true);
  const [selectedTitle, setSelectedTitle] = useState(null);
  const [selectedTerms, setSelectedTerms] = useState(0);
  const [selectedTaxGroup, setSelectedTaxGroup] = useState(0);
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedCustomImage, setSelectedCustomImage] = useState("");
  const [selectOverrideDefaultTaxForSale, setSelectOverrideDefaultTaxForSale] =
    useState(false);
  const [selectCustomCheckBox, setSelectCustomCheckBox] = useState(false);
  const [selectedCustomField, setSelectedCustomField] = useState("");
  const [customFields, setCustomFields] = useState([]);
  const [fileDetails, setFileDetails] = useState([]);
  const [supplierInfoId, setSupplierInfoId] = useState(1);
  const [comment,setComment]=useState(false)
  const [internalnotes,setInternalNotes]=useState(false)
  // const [supplierdetails,setSupplierDetails]=useState({})
  const [supplydata,setSupplyData]=useState(false)
  const [termsDropdown, setTermsDropdown] = useState([]);
  const paramObject = useParams();
  let navigate = useNavigate();
  const token = localStorage.getItem("Token");
  // const terms = [{ label: "None", value: 0 }];
  const Id = localStorage.getItem("ID");

  const validationSchema = Yup.object().shape({
    CompanyName: Yup.string().required("Comapany Name is required"),
    // FirstName: Yup.string().required("First Name is required"),
    // LastName: Yup.string().required("Last Name is required"),
    // EMail: Yup.string().email().required("E-Mail is required"),
    // PhoneNumber: Yup.string()
    //   .max(15, "Phone number must be at most 15 digits")
    //   .matches(/^\d+$/, "Phone number must only contain digits")
    //   .required("Phone number is required"),
    // Address1: Yup.string().required("Address 1 is required"),
    // Address2: Yup.string().required("Address 2 is required"),
    // City: Yup.string().required("City is required"),
    // StateProvince: Yup.string().required("State/Province is required"),
    // Zip: Yup.string()
    // .required("Zip is required")
    // .min(6, "Zip Code must be at least 6 digits")
    // .max(6, "Zip Code must be at most 6 digits"),
    // Country: Yup.string().required("Country is required"),
    // TaxPercent1: Yup.number().notRequired(),
    // TaxPercent2: Yup.number().notRequired(),
    // TaxPercent3: Yup.number().notRequired(),
    // TaxPercent4: Yup.number().notRequired(),
    // TaxPercent5: Yup.number().notRequired(),
    // Account: Yup.number().required("Account Number is required"),
    // Openingbalance: Yup.number().required("Opening Balance is required"),
    // Balance: Yup.number().required("Store Account Balance is required"),
  });

  const title = [
    { label: "Mr.", value: "Mr." },
    { label: "Mrs.", value: "Mrs." },
    { label: "Dr.", value: "Dr." },
    { label: "Hon.", value: "Hon." },
    { label: "Prof.", value: "Prof." },
    { label: "Rev.", value: "Rev." },
    { label: "Rt. Hon.", value: "Rt. Hon." },
    { label: "Sr.", value: "Sr." },
    { label: "Jr.", value: "Jr." },
    { label: "St.", value: "St." },
  ];

  const submitClick = (id) => {
    setSupplierInfoId(id);
  };

  // For Terms
  let terms = [];
  const TermsDropdown = termsDropdown.map((u, i) => {
    terms[i] = {
      label: u.Name,
      value: u.ID,
      days: u.Value,
    };
  });

  const handleShowMore = () => {
    setShowMore(!showMore);
    setDisableCumulative(true);
  };

  const handleSelectCustomCheckBox = () => {
    setSelectCustomCheckBox(!selectCustomCheckBox);
  };

  const _handleFileChange = (e, index) => {
    setChangeImagename(true);

    if (vaidation(e.target.name, e?.currentTarget?.files[0])) {
      uploadFile(e?.currentTarget?.files[0], e.target.name, index);
    }
  };

  const handleSelectOverrideDefaultTaxForSale = () => {
    setSelectOverrideDefaultTaxForSale(true);
  };

  const selectStyles = {
    // dropdown input css
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      height: "40px",
      position: "relative",
      border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
      "&:hover": {
        border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      },
    }),
    // dropdown menu css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
      position: "absolute",
      "z-index": "999",
      background: "#f8f8f8",
      width: "100%",
    }),
    // dropdown option css
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
      "&:hover": {
        backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
      },
    }),
  };

  const vaidation = (name, value) => {
    switch (name) {
      case "SelectImage":
        if (!value.name.match(/\.(jpg|jpeg|png|gif|mp4)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };

  const handleCustomFieldsValues = (event, fieldTypeName, fieldName) => {
    // console.log("fieldTypeName::>>",fieldTypeName)
    if (fieldTypeName === "Dropdown") {
      customFieldSupplierValues[fieldName] = {
        CustomFieldLabelID: fieldName,
        CustomFieldValue: event.value,
      };
    } else if (fieldTypeName === "File") {
      // console.log("Image file:---", fieldTypeName);
      customFieldSupplierValues[event.target.name] = {
        CustomFieldLabelID: event.target.name,
        CustomFieldValue: event.target.value,
      };
    } else if (fieldTypeName === "Checkbox") {
      // console.log("event.target.checked",event.target.checked)
      customFieldSupplierValues[event.target.name] = {
        CustomFieldLabelID: event.target.name,
        CustomFieldValue: event.target.checked ? true : false,
      };
    } else if (fieldName === "E-Mail") {
      customFieldSupplierValues[event.target.name] = {
        CustomFieldLabelID: event.target.name,
        CustomFieldValue: event.target.value,
      };
    } else if (fieldName === "Website") {
      customFieldSupplierValues[event.target.name] = {
        CustomFieldLabelID: event.target.name,
        CustomFieldValue: event.target.value,
      };
    } else if (fieldName === "PhoneNumber") {
      customFieldSupplierValues[event.target.name] = {
        CustomFieldLabelID: event.target.name,
        CustomFieldValue: event.target.value,
      };
    } else if (fieldName === "Date") {
      customFieldSupplierValues[event.target.name] = {
        CustomFieldLabelID: event.target.name,
        CustomFieldValue: event.target.value,
      };
    } else {
      // console.log("dataaaaaa")
      customFieldSupplierValues[event.target.name] = {
        CustomFieldLabelID: event.target.name,
        CustomFieldValue: event.target.value,
      };
    }
  };

  const uploadFile = async (file, type) => {
    setBtnLoader({ [type]: true });
    await uploadAWS(file, AWS_IMAGE_FOLDER_SUPPLIERS, (data) => {
      if (data) {
        if (type === "SelectImage") setImageUrl(data);
        else if (type === "File1") setFile1Url(data);
        else if (type === "File2") setFile2Url(data);
        else if (type === "File3") setFile3Url(data);
        else if (type === "File4") setFile4Url(data);
        else if (type === "File5") setFile5Url(data);
        else {
          customFieldSupplierValues[type] = {
            CustomFieldLabelID: type,
            CustomFieldValue: data,
          };
          setCustomFileUrl(data);
          // console.log("customFileUrl", customFileUrl);
          setLoading(false);
        }
      }
    });
  };

  const handleSubmit = (values) => {
    let taxValues = [
      {
        TaxId: values?.TaxId1,
        TaxName: values?.TaxName1,
        TaxPercent: values?.TaxPercent1,
        TaxCumulative: values?.Cumulative,
      },
      {
        TaxId: values?.TaxId2,
        TaxName: values?.TaxName2,
        TaxPercent: values?.TaxPercent2,
        TaxCumulative: values?.Cumulative,
      },
      {
        TaxId: values?.TaxId3,
        TaxName: values?.TaxName3,
        TaxPercent: values?.TaxPercent3,
        TaxCumulative: values?.Cumulative,
      },
      {
        TaxId: values?.TaxId4,
        TaxName: values?.TaxName4,
        TaxPercent: values?.TaxPercent4,
        TaxCumulative: values?.Cumulative,
      },
      {
        TaxId: values?.TaxId5,
        TaxName: values?.TaxName5,
        TaxPercent: values?.TaxPercent5,
        TaxCumulative: values?.Cumulative,
      },
    ];

    let fileValues = [
      {
        FilesId: values?.FileId1,
        FileName: File1Url,
      },
      {
        FilesId: values?.FileId2,
        FileName: File2Url,
      },
      {
        FilesId: values?.FileId3,
        FileName: File3Url,
      },
      {
        FilesId: values?.FileId4,
        FileName: File4Url,
      },
      {
        FilesId: values?.FileId5,
        FileName: File5Url,
      },
    ];

    let taxdata = taxValues.filter(function (rowData) {
      return rowData.TaxName != "";
    });

    let filedata = fileValues.filter(function (rowData) {
      return rowData.FileName != "";
    });

    let customFielddata = customFieldSupplierValues.filter(function (rowData) {
      return (
        rowData.CustomFieldLabelID !== null && rowData.CustomFieldValue !== null
      );
    });

    let taxValuesData = {};
    let fileValuesData = {};
    let customValuesData = {};

    taxValuesData.supplierTaxXML = taxdata;
    fileValuesData.supplierFilesXML = filedata;
    customValuesData.customValueXML = customFielddata;

    let taxjsonstring = JSON.stringify(taxValuesData);
    let filejsonstring = JSON.stringify(fileValuesData);
    let customvaluejsonstring = JSON.stringify(customValuesData);

    // console.log("customvaluejsonstring: ", customvaluejsonstring);

    let suppliersData = {
      xmlsuppliertax: taxjsonstring,
      xmlsupplierfiles: filejsonstring,
      xmlcustomfieldvalue: customvaluejsonstring,
      id: paramObject.id || 0,
      companyname: values.CompanyName,
      firstname:
        selectedTitle === null
          ? values.FirstName
          : selectedTitle.value + " " + values.FirstName,
      lastname: values.LastName,
      email: values.EMail,
      phonenumber: values.PhoneNumber,
      selectimage: ImageUrl,
      address1: values.Address1,
      address2: values.Address2,
      city: values.City,
      state: values.StateProvince,
      zip: values.Zip,
      country: values.Country,
      comments: values.Comments,
      internalnotes: values.InternalNotes,
      accountnumber: values.Account,
      terms: selectedTerms?.value,
      openingbalance: values.Openingbalance=== "" ? 0 : values.Openingbalance,
      balance: values.Balance,
      overridedefaulttax: values.OverrideDefaultTaxForSale,
      taxgroup: selectedTaxGroup.value,
      loginuserid: Id,
    };

//     console.log(suppliersData, "suppliersData")
// return
    setLoading(true);
    axios
      .post(`${config.suppliersBaseUrl}/suppliers/upsert`, suppliersData, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
          // navigate("/suppliers");
          navigate(-1);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError("Email" + ALREADY_EXIST);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -3
        ) {
          toastError("Account Number" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    // Binding Customer Fields
    axios
      .get(
        `${config.suppliersBaseUrl}/suppliers/supplierscustomgetall?id=${Id}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // Taking the the custom fields
        setCustomFields(res.data.ResponseData.customefield);
      })
      .catch((err) => {
        // console.log("Error: ", err);
        setLoading(false);
      });

    if (paramObject.id > 0) {
      setLoading(true);

      axios
        .get(
          `${config.suppliersBaseUrl}/suppliers/findbyid?id=${paramObject.id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          // console.log("Response:------------", res.data.ResponseData);
          const suppliersData = res?.data?.ResponseData?.Items[0];
          const taxData = res.data.ResponseData.SuppliersTax;
          const fileData = res.data.ResponseData.SuppliersFiles;
          const customFieldValueData = res.data.ResponseData.CustomFieldValues;
          setFileDetails(res.data.ResponseData.SuppliersFiles);
          // setSupplierDetails(suppliersData)
          // setSupplyData(true)
          // setSelectedCustomImage()
          // setCustomState(res.data.ResponseData.CustomFieldValues);

          let firstname = suppliersData.FirstName.split(" ");

          setSelectOverrideDefaultTaxForSale(
            suppliersData.Overridedefaulttax === 1 ? true : false
          );

          title.map((selectTitle) => {
            if (selectTitle.value == firstname[0]) {
              setSelectedTitle(selectTitle);
              // console.log(selectedTitle);
            }
          });

          // console.log(suppliersData?.Terms, "terms get")
          setSelectedTerms(suppliersData?.Terms);
          terms.map((selectterm) => {

            if (selectterm.value == suppliersData.TaxGroup) {
              setSelectedTaxGroup(selectterm);
              // console.log(selectedTaxGroup);
            }
          });

          setSelectTaxable(suppliersData.Taxable === 1 ? true : false);
          setImageUrl(suppliersData.SelectImage);
          setDisableCumulative(taxData[1]?.Cumulative === 1 ? true : false);

          if (taxData.length > 2) {
            setShowMore(true);
          }

          const data = {
            CompanyName: suppliersData.CompanyName,
            Title: firstname[0],
            FirstName: firstname[1],
            LastName: suppliersData.LastName,
            EMail: suppliersData.Email,
            PhoneNumber: suppliersData.PhoneNumber,
            SelectImage: suppliersData.SelectImage,
            Address1: suppliersData.Address1,
            Address2: suppliersData.Address2,
            City: suppliersData.City,
            StateProvince: suppliersData.State,
            Zip: suppliersData.Zip,
            Country: suppliersData.Country,
            Comments: suppliersData.Comments,
            InternalNotes: suppliersData.Internalnotes,
            Account: suppliersData.Accountnumber,
            Terms: suppliersData.Terms,
            Openingbalance: suppliersData.Openingbalance,
            Balance: parseFloat(suppliersData.Balance).toFixed(2),
            OverrideDefaultTaxForSale:
              suppliersData.Overridedefaulttax === 1 ? true : false,
            TaxGroup: suppliersData.TaxGroup,
            TaxId1: taxData[0]?.Id,
            TaxName1: taxData[0]?.Name,
            TaxPercent1: taxData[0]?.Percent,
            TaxId2: taxData[1]?.Id,
            TaxName2: taxData[1]?.Name,
            TaxPercent2: taxData[1]?.Percent,
            Cumulative: taxData[1]?.Cumulative === 1 ? true : false,
            TaxId3: taxData[2]?.Id,
            TaxName3: taxData[2]?.Name,
            TaxPercent3: taxData[2]?.Percent,
            TaxId4: taxData[3]?.Id,
            TaxName4: taxData[3]?.Name,
            TaxPercent4: taxData[3]?.Percent,
            TaxId5: taxData[4]?.Id,
            TaxName5: taxData[4]?.Name,
            TaxPercent5: taxData[4]?.Percent,
            FileId1: fileData[0]?.Id,
            File1: "",
            FileId2: fileData[1]?.Id,
            File2: "",
            FileId3: fileData[2]?.Id,
            File3: "",
            FileId4: fileData[3]?.Id,
            File4: "",
            FileId5: fileData[4]?.Id,
            File5: "",
          };

          const newData = { ...data };
          for (let i = 0; i < customFieldValueData.length; i++) {
            newData[customFieldValueData[i].SupplierCustomFieldControlID] =
              customFieldValueData[i].Value === "false"
                ? false
                : customFieldValueData[i].Value === "true"
                ? true
                : customFieldValueData[i].Value;
          }

          setFormValues(newData);
          // console.log("formValues: ", formValues);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    }

      // Accounting Terms Drop Down Axios Call
      axios
      .get(`${config.generalBaseUrl}/generals/termsddl`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        // console.log(res.data.ResponseData, "terms list");
        setTermsDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });





  }, []);

  const previoudPage = () => {
    navigate(-1);
  };

  // console.log("Supplier Button Details:---", supplierInfoId);

  // console.log(supplierdetails, "supply")

  return (

    <>
    
    <div className={paramObject.id > 0 ? "col-lg-10 col-md-12" : "col-lg-12 col-md-12"}>
   
    <div className="card bg-white">
      <Formik
        {...props}
        initialValues={formValues}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={handleSubmit}
      >
        {({ errors, touched, handleChange, validateForm }) => (
          <Form>
            <div className="card-header">
              <h5 className="card-title">Supplier Information</h5>
            </div>
            <div className="card-body">
              <ul className="nav nav-tabs mb-5" role="tablist">
                <li className="nav-item fs-6" role="presentation">
                  <a
                    className="nav-link active"
                    href="javascript:void(0);"
                    data-bs-toggle="tab"
                    aria-selected="false"
                    role="tab"
                    // tabindex="-1"
                    onClick={() => submitClick(1)}
                  >
                    Personal Details
                  </a>
                </li>
                <li className="nav-item fs-6" role="presentation">
                  <a
                    className="nav-link"
                    href="javascript:void(0);"
                    data-bs-toggle="tab"
                    aria-selected="false"
                    role="tab"
                    // tabindex="-1"
                    onClick={() => submitClick(2)}
                  >
                    Address
                  </a>
                </li>
                <li className="nav-item fs-6" role="presentation">
                  <a
                    className="nav-link"
                    href="javascript:void(0);"
                    data-bs-toggle="tab"
                    aria-selected="false"
                    role="tab"
                    // tabindex="-1"
                    onClick={() => submitClick(3)}
                  >
                    Account Balance
                  </a>
                </li>
                {/* <li className="nav-item fs-6" role="presentation">
                  <a
                    className="nav-link"
                    href="javascript:void(0);"
                    data-bs-toggle="tab"
                    aria-selected="true"
                    role="tab"
                    onClick={() => submitClick(4)}
                  >
                    Tax
                  </a>
                </li> */}
                <li className="nav-item fs-6" role="presentation">
                  <a
                    className="nav-link"
                    href="javascript:void(0);"
                    data-bs-toggle="tab"
                    aria-selected="true"
                    role="tab"
                    onClick={() => submitClick(5)}
                  >
                    Custom Fields
                  </a>
                </li>
                <li className="nav-item fs-6" role="presentation">
                  <a
                    className="nav-link"
                    href="javascript:void(0);"
                    data-bs-toggle="tab"
                    aria-selected="true"
                    role="tab"
                    onClick={() => submitClick(6)}
                  >
                    Files
                  </a>
                </li>
               
              </ul>
              {supplierInfoId === 1 ? (
                <>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className=" row">
                        <label className="col-form-label col-md-4 form-label">
                          Company Name
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-md-8">
                          <Field
                            type="text"
                            className={`form-control form-control-sm ${
                              errors.CompanyName ? "is-invalid" : ""
                            }`}
                            onChange={handleChange}
                            id="CompanyName"
                            name="CompanyName"
                          />
                          <div className="invalid-feedback">
                            {touched.CompanyName && errors.CompanyName
                              ? errors.CompanyName
                              : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className=" row">
                        <label className="col-form-label col-md-4 form-label">
                          First Name 
                          {/* <span className="text-danger">*</span> */}
                        </label>
                        <div className="col-lg-8">
                          <div className="row">
                            <div className="col-lg-5 pe-0">
                              <Select
                                backspaceRemovesValue={false}
                                controlShouldRenderValue={true}
                                hideSelectedOptions={true}
                                isClearable={true}
                                onChange={setSelectedTitle}
                                options={title}
                                placeholder=""
                                styles={selectStyles}
                                value={selectedTitle}
                                id="Title"
                                name="Title"
                                className="custom-search-select"
                              />
                            </div>
                            <div className="col-lg-7 ps-0">
                              <Field
                                type="text"
                                className={`form-control form-control-sm ${
                                  errors.FirstName ? "is-invalid" : ""
                                }`}
                                onChange={handleChange}
                                id="FirstName"
                                name="FirstName"
                              />
                              <div className="invalid-feedback">
                                {touched.FirstName && errors.FirstName
                                  ? errors.FirstName
                                  : ""}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className=" row">
                        <label className="col-form-label col-md-4 form-label">
                          Last Name 
                          {/* <span className="text-danger">*</span> */}
                        </label>
                        <div className="col-md-8">
                          <Field
                            type="text"
                            className={`form-control form-control-sm ${
                              errors.LastName ? "is-invalid" : ""
                            }`}
                            onChange={handleChange}
                            id="LastName"
                            name="LastName"
                          />
                          <div className="invalid-feedback">
                            {touched.LastName && errors.LastName
                              ? errors.LastName
                              : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className=" row">
                        <label className="col-form-label col-md-4 form-label">
                          E-Mail 
                          {/* <span className="text-danger">*</span> */}
                        </label>
                        <div className="col-md-8">
                          <Field
                            type="text"
                            className={`form-control form-control-sm ${
                              errors.EMail ? "is-invalid" : ""
                            }`}
                            onChange={handleChange}
                            id="EMail"
                            name="EMail"
                          />
                          <div className="invalid-feedback">
                            {touched.EMail && errors.EMail ? errors.EMail : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className=" row">
                        <label className="col-form-label col-md-4 form-label">
                          Phone Number 
                          {/* <span className="text-danger">*</span> */}
                        </label>
                        <div className="col-md-8">
                          {/* <Field
                            type="text"
                            className={`form-control ${
                              errors.EMail ? "is-invalid" : ""
                            }`}
                            onChange={handleChange}
                            id="EMail"
                            name="EMail"
                          /> */}
                          <Field
                            type="number"
                            // max={10}
                            pattern="[0-9]*"
                            maxLength={10}
                            // maxlength="10"
                            className={`form-control form-control-sm ${
                              errors.PhoneNumber
                                ? "is-invalid custom-invalid-border"
                                : ""
                            }`}
                            onChange={handleChange}
                            id="PhoneNumber"
                            name="PhoneNumber"
                          />
                          <div className="invalid-feedback">
                            {touched.PhoneNumber && errors.PhoneNumber
                              ? errors.PhoneNumber
                              : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className=" row">
                        <label className="col-form-label col-md-4 form-label">
                          Select Image
                        </label>
                        <div className="col-md-8">
                          <Field
                            type="file"
                            name="SelectImage"
                            id="SelectImage"
                            className={`form-control form-control-sm`}
                            value={selectedImage}
                            onChange={_handleFileChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6"></div>
                    <div className="col-sm-6">
                      <div
                        className={`${
                          ImageUrl ? "" : selectedImage ? "" : "d-none"
                        }  row`}
                      >
                        <label className="col-form-label col-md-4 form-label"></label>
                        <div className="col-md-8">
                          <img
                            src={`${ImageUrl ? ImageUrl : selectedImage}`}
                            alt="Category Image"
                            className="ImagePreviewSize"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}

              {supplierInfoId === 2 ? (
                <>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className=" row">
                        <label className="col-form-label col-md-4 form-label">
                          Address 1 
                          {/* <span className="text-danger">*</span> */}
                        </label>
                        <div className="col-md-8">
                          <Field
                            // type="textarea"
                            as="textarea"
                            className={`form-control form-control-sm ${
                              errors.Address1
                                ? "is-invalid custom-invalid-border"
                                : ""
                            }`}
                            onChange={handleChange}
                            id="Address1"
                            name="Address1"
                          />
                          <div className="invalid-feedback">
                            {touched.Address1 && errors.Address1
                              ? errors.Address1
                              : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className=" row">
                        <label className="col-form-label col-md-4 form-label">
                          Address 2 
                          {/* <span className="text-danger">*</span> */}
                        </label>
                        <div className="col-md-8">
                          <Field
                            // type="text"
                            as="textarea"
                            className={`form-control form-control-sm ${
                              errors.Address2
                                ? "is-invalid custom-invalid-border"
                                : ""
                            }`}
                            onChange={handleChange}
                            id="Address2"
                            name="Address2"
                          />
                          <div className="invalid-feedback">
                            {touched.Address2 && errors.Address2
                              ? errors.Address2
                              : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className=" row">
                        <label className="col-form-label col-md-4 form-label">
                          City 
                          {/* <span className="text-danger">*</span> */}
                        </label>
                        <div className="col-md-8 mt-1">
                          <Field
                            type="text"
                            className={`form-control form-control-sm ${
                              errors.City ? "is-invalid" : ""
                            }`}
                            onChange={handleChange}
                            id="City"
                            name="City"
                          />
                          <div className="invalid-feedback">
                            {touched.City && errors.City ? errors.City : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className=" row">
                        <label className="col-form-label col-md-4 form-label">
                          State/Province 
                          {/* <span className="text-danger">*</span> */}
                        </label>
                        <div className="col-md-8 mt-1">
                          <Field
                            type="text"
                            className={`form-control form-control-sm ${
                              errors.StateProvince ? "is-invalid" : ""
                            }`}
                            onChange={handleChange}
                            id="StateProvince"
                            name="StateProvince"
                          />
                          <div className="invalid-feedback">
                            {touched.StateProvince && errors.StateProvince
                              ? errors.StateProvince
                              : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className=" row">
                        <label className="col-form-label col-md-4 form-label">
                          Zip Code 
                          {/* <span className="text-danger">*</span> */}
                        </label>
                        <div className="col-md-8 mt-1">
                          <Field
                            type="text"
                            className={`form-control form-control-sm ${
                              errors.Zip ? "is-invalid" : ""
                            }`}
                            onChange={handleChange}
                            id="Zip"
                            name="Zip"
                            maxLength="6"
                          />
                          <div className="invalid-feedback">
                            {touched.Zip && errors.Zip ? errors.Zip : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className=" row">
                        <label className="col-form-label col-md-4 form-label">
                          Country 
                          {/* <span className="text-danger">*</span> */}
                        </label>
                        <div className="col-md-8 mt-1">
                          <Field
                            type="text"
                            className={`form-control form-control-sm ${
                              errors.Country ? "is-invalid" : ""
                            }`}
                            onChange={handleChange}
                            id="Country"
                            name="Country"
                          />
                          <div className="invalid-feedback">
                            {touched.Country && errors.Country
                              ? errors.Country
                              : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}

              {supplierInfoId === 3 ? (
                <>
                  {/* <div className="row">
                    <div className="col-sm-6">
                      <div className=" row">
                        <label className="col-form-label col-md-4 form-label">
                          Comments
                        </label>
                        <div className="col-md-8">
                          <Field
                            as="textarea"
                            className="form-control"
                            onChange={handleChange}
                            id="Comments"
                            name="Comments"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className=" row">
                        <label className="col-form-label col-md-4 form-label">
                          Internal Notes
                        </label>
                        <div className="col-md-8">
                          <Field
                            as="textarea"
                            className="form-control"
                            onChange={handleChange}
                            id="InternalNotes"
                            name="InternalNotes"
                          />
                        </div>
                      </div>
                    </div>
                  </div> */}
                  <div className="row">
                    <div className="col-sm-6">
                      <div className=" row">
                        <label className="col-form-label col-md-4 form-label">
                          Bank Account No 
                          {/* <span className="text-danger">*</span> */}
                        </label>
                        <div className="col-md-8 mt-1">
                          <Field
                            type="number"
                            // className="form-control"
                            className={`form-control form-control-sm ${
                              errors.Account ? "is-invalid" : ""
                            }`}
                            onChange={handleChange}
                            id="Account"
                            name="Account"
                          />
                          <div className="invalid-feedback">
                            {touched.Account && errors.Account
                              ? errors.Account
                              : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className=" row">
                        <label className="col-form-label col-md-4 form-label">
                          Terms
                        </label>
                        <div className="col-md-8">
                          <Select
                            backspaceRemovesValue={false}
                            controlShouldRenderValue={true}
                            hideSelectedOptions={true}
                            isClearable={true}
                            onChange={setSelectedTerms}
                            options={terms}
                            placeholder="Select Terms"
                            styles={selectStyles}
                            value={terms.find(
                              (option) => option?.value == selectedTerms //selectedTerm
                            )}
                            id="Terms"
                            name="Terms"
                            className="custom-search-select"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className=" row">
                        <label className="col-form-label col-md-4 form-label">
                          Opening Balance 
                          {/* <span className="text-danger">*</span> */}
                        </label>
                        <div className="col-md-8">
                          <Field
                            type="number"
                            className={`form-control form-control-sm ${
                              errors.Openingbalance ? "is-invalid" : ""
                            }`}
                            onChange={handleChange}
                            id="Openingbalance"
                            name="Openingbalance"
                            disabled={paramObject.id>0 ? true: false}
                          />
                          <div className="invalid-feedback">
                            {touched.Openingbalance && errors.Openingbalance
                              ? errors.Openingbalance
                              : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-sm-6">
                      <div className=" row">
                        <label className="col-form-label col-md-4 form-label">
                          Store Account Balance
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-md-8">
                          <Field
                            type="number"
                            className={`form-control form-control-sm ${
                              errors.Balance ? "is-invalid" : ""
                            }`}
                            onChange={handleChange}
                            id="Balance"
                            name="Balance"
                            disabled={paramObject.id>0 ? true: false}
                          />
                          <div className="invalid-feedback">
                            {touched.Balance && errors.Balance
                              ? errors.Balance
                              : ""}
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </>
              ) : (
                ""
              )}

              {supplierInfoId === 4 ? (
                <>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className=" row">
                        <label className="col-form-label col-md-2 form-label">
                          Override Default Tax For Sale
                        </label>
                        <div className="col-md-8">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="OverrideDefaultTaxForSale"
                            name="OverrideDefaultTaxForSale"
                            onChange={handleChange}
                            onInput={handleSelectOverrideDefaultTaxForSale}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`${
                      selectOverrideDefaultTaxForSale === true ? "" : "d-none"
                    }`}
                  >
                    <div className="row">
                      <div className="col-sm-12">
                        <div className=" row">
                          <label className="col-form-label col-md-2 form-label">
                            Tax Group
                          </label>
                          <div className="col-md-9">
                            <Select
                              backspaceRemovesValue={false}
                              controlShouldRenderValue={true}
                              hideSelectedOptions={true}
                              isClearable={true}
                              onChange={setSelectedTaxGroup}
                              options={terms}
                              placeholder=""
                              styles={selectStyles}
                              value={selectedTaxGroup}
                              id="TaxGroup"
                              name="TaxGroup"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="">
                          <h4 className="text-center bold">OR</h4>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className=" row">
                          <label className="col-form-label col-md-1 form-label">
                            Tax 1
                          </label>
                          <div className="col-md-5">
                            <Field type="hidden" name="TaxId1" />
                            <Field
                              type="text"
                              className="form-control"
                              onChange={handleChange}
                              id="TaxName1"
                              name="TaxName1"
                              placeholder="Tax Name"
                            />
                          </div>
                          <div className="col-md-5">
                            <Field
                              type="text"
                              className={`form-control ${
                                errors.TaxPercent1 ? "is-invalid" : ""
                              }`}
                              onChange={handleChange}
                              id="TaxPercent1"
                              name="TaxPercent1"
                              placeholder="Tax Percent"
                            />
                            <div className="invalid-feedback">
                              {touched.TaxPercent1 && errors.TaxPercent1
                                ? errors.TaxPercent1
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className=" row">
                          <label className="col-form-label col-md-1 form-label">
                            Tax 2
                          </label>
                          <div className="col-md-5">
                            <Field type="hidden" name="TaxId2" />
                            <Field
                              type="text"
                              className="form-control"
                              onChange={handleChange}
                              id="TaxName2"
                              name="TaxName2"
                              placeholder="Tax Name"
                            />
                          </div>
                          <div className="col-md-4">
                            <Field
                              type="text"
                              className={`form-control ${
                                errors.TaxPercent2 ? "is-invalid" : ""
                              }`}
                              onChange={handleChange}
                              id="TaxPercent2"
                              name="TaxPercent2"
                              placeholder="Tax Percent"
                            />
                            <div className="invalid-feedback">
                              {touched.TaxPercent2 && errors.TaxPercent2
                                ? errors.TaxPercent2
                                : ""}
                            </div>
                          </div>
                          <div className="col-md-2">
                            {/* <span>%</span> */}
                            <Field
                              className="form-check-input"
                              style={{ width: "1.5em", height: "1.5em" }}
                              type="checkbox"
                              id="Cumulative"
                              name="Cumulative"
                              onChange={handleChange}
                              disabled={disableCumulative}
                            />
                            <span> Cumulative</span>
                          </div>
                          <div
                            className={`col-form-label col-md-4 form-label mt-3 ${
                              showMore === false ? "" : "d-none"
                            }`}
                          >
                            <Link onClick={handleShowMore}>Show More</Link>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={`${showMore === true ? "" : "d-none"}`}>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className=" row">
                            <label className="col-form-label col-md-1 form-label">
                              Tax 3:
                            </label>
                            <div className="col-md-5">
                              <Field type="hidden" name="TaxId3" />
                              <Field
                                type="text"
                                className="form-control"
                                onChange={handleChange}
                                id="TaxName3"
                                name="TaxName3"
                                placeholder="Tax Name"
                              />
                            </div>
                            <div className="col-md-5">
                              <Field
                                type="text"
                                className={`form-control ${
                                  errors.TaxName3 ? "is-invalid" : ""
                                }`}
                                onChange={handleChange}
                                id="TaxPercent3"
                                name="TaxPercent3"
                                placeholder="Tax Percent"
                              />
                              <div className="invalid-feedback">
                                {touched.TaxName3 && errors.TaxName3
                                  ? errors.TaxName3
                                  : ""}
                              </div>
                              {/* <span>%</span> */}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className=" row">
                            <label className="col-form-label col-md-1 form-label">
                              Tax 4
                            </label>
                            <div className="col-md-5">
                              <Field type="hidden" name="TaxId4" />
                              <Field
                                type="text"
                                className="form-control"
                                onChange={handleChange}
                                id="TaxName4"
                                name="TaxName4"
                                placeholder="Tax Name"
                              />
                            </div>
                            <div className="col-md-5">
                              <Field
                                type="text"
                                className={`form-control ${
                                  errors.TaxName4 ? "is-invalid" : ""
                                }`}
                                onChange={handleChange}
                                id="TaxPercent4"
                                name="TaxPercent4"
                                placeholder="Tax Percent"
                              />
                              <div className="invalid-feedback">
                                {touched.TaxName4 && errors.TaxName4
                                  ? errors.TaxName4
                                  : ""}
                              </div>
                              {/* <span>%</span> */}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className=" row">
                            <label className="col-form-label col-md-1 form-label">
                              Tax 5
                            </label>
                            <div className="col-md-5">
                              <Field type="hidden" name="TaxId5" />
                              <Field
                                type="text"
                                className="form-control"
                                onChange={handleChange}
                                id="TaxName5"
                                name="TaxName5"
                                placeholder="Tax Name"
                              />
                            </div>
                            <div className="col-md-5">
                              <Field
                                type="text"
                                className={`form-control ${
                                  errors.TaxName5 ? "is-invalid" : ""
                                }`}
                                onChange={handleChange}
                                id="TaxPercent5"
                                name="TaxPercent5"
                                placeholder="Tax Percent"
                              />
                              <div className="invalid-feedback">
                                {touched.TaxName5 && errors.TaxName5
                                  ? errors.TaxName5
                                  : ""}
                              </div>
                              {/* <span>%</span> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}

              {supplierInfoId === 5 ? (
                <>
                  <div className="row">
                    {customFields?.map((data, index) => (
                      <>
                        <label
                          className="col-form-label col-md-2 form-label mb-3"
                          key={index}
                        >
                          {data.Name}
                        </label>
                        <div className="col-md-4">
                          {data.TypeName === "Text" ? (
                            <Field
                              key={index}
                              type="text"
                              className="form-control"
                              onChange={(event) => {
                                handleChange(event);
                                handleCustomFieldsValues(
                                  event,
                                  data.TypeName,
                                  data.Name
                                );
                              }}
                              id={data.TypeName}
                              name={data.Id}
                            />
                          ) : data.TypeName === "E-Mail" ? (
                            <Field
                              key={index}
                              type="email"
                              className="form-control"
                              onChange={(event) => {
                                handleChange(event);
                                handleCustomFieldsValues(
                                  event,
                                  data.TypeName,
                                  data.Name
                                );
                              }}
                              id={data.TypeName}
                              name={data.Id}
                            />
                          ) : data.TypeName === "Dropdown" ? (
                            <>
                              <Select
                                key={index}
                                onChange={(event) => {
                                  handleCustomFieldsValues(
                                    event,
                                    data.TypeName,
                                    data.Id
                                  );
                                  setSelectedCustomField(event);
                                }}
                                options={data?.Optionvalue.split(",").map(
                                  (option) => ({
                                    label: option,
                                    value: option,
                                    selected: option === formValues[data.Id],
                                  })
                                )}
                                placeholder="Select"
                                styles={selectStyles}
                                defaultValue={
                                  formValues[data.Id] !== null &&
                                  formValues[data.Id] !== ""
                                    ? {
                                        label: formValues[data.Id],
                                        value: formValues[data.Id],
                                      }
                                    : ""
                                }
                                id={data.TypeName}
                                name={data.Id}
                              />
                            </>
                          ) : data.TypeName === "Checkbox" ? (
                            <Field
                              key={index}
                              className="form-check-input form-control"
                              style={{
                                width: "1.5em",
                                height: "1.5em",
                              }}
                              type="checkbox"
                              id={data.TypeName}
                              name={data.Id}
                              onChange={(event) => {
                                handleCustomFieldsValues(
                                  event,
                                  data.TypeName,
                                  data.Name
                                );
                                handleChange(event);
                              }}
                              onInput={handleSelectCustomCheckBox}
                            />
                          ) : data.TypeName === "Website" ? (
                            <Field
                              key={index}
                              type="text"
                              className="form-control"
                              onChange={(event) => {
                                handleChange(event);
                                handleCustomFieldsValues(
                                  event,
                                  data.TypeName,
                                  data.Name
                                );
                              }}
                              id={data.TypeName}
                              name={data.Id}
                            />
                          ) : data.TypeName === "PhoneNumber" ? (
                            <Field
                              key={index}
                              type="tel"
                              className="form-control"
                              id={data.TypeName}
                              name={data.Id}
                              onChange={(event) => {
                                handleChange(event);
                                handleCustomFieldsValues(
                                  event,
                                  data.TypeName,
                                  data.Name
                                );
                              }}
                            />
                          ) : data.TypeName === "Date" ? (
                            <Field
                              key={index}
                              className="form-control"
                              type="date"
                              id={data.TypeName}
                              name={data.Id}
                              onChange={(event) => {
                                handleChange(event);
                                handleCustomFieldsValues(
                                  event,
                                  data.TypeName,
                                  data.Name
                                );
                              }}
                            />
                          ) : data.TypeName === "Image" ? (
                            <>
                              <div className="row">
                                <FileInput
                                  key={index}
                                  className="form-control"
                                  id={data.TypeName}
                                  name={data.Id}
                                  value={selectedCustomImage}
                                  accept="image/*"
                                  handleChange={(event) => {
                                    _handleFileChange(event, index);
                                    handleCustomFieldsValues(
                                      event,
                                      data.TypeName,
                                      data.Name
                                    );
                                  }}
                                />
                              </div>
                              <div className="row">
                                <div className="mt-2">
                                  <div
                                    className={`${
                                      formValues[data.Id]
                                        ? ""
                                        : selectedCustomImage
                                        ? ""
                                        : "d-none"
                                    }  row`}
                                  >
                                    <label className="col-form-label col-md-2 form-label"></label>
                                    <div>
                                      <img
                                        src={`${
                                          formValues[data.Id]
                                            ? formValues[data.Id]
                                            : selectedCustomImage
                                        }`}
                                        alt="Custom Image"
                                        className="ImagePreviewSize"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : data.TypeName === "File" ? (
                            <>
                              <FileInput
                                key={index}
                                className="form-control"
                                id={data.TypeName}
                                name={data.Id}
                                // value={data.Value}
                                handleChange={(event) => {
                                  _handleFileChange(event, index);
                                  handleCustomFieldsValues(
                                    event,
                                    data.TypeName,
                                    data.Name
                                  );
                                }}
                              />
                              {formValues[data.Id] ? (
                                <a
                                  target="_blank"
                                  href={
                                    formValues[data.Id]
                                      ? formValues[data.Id]
                                      : ""
                                  }
                                >
                                  Attachment
                                </a>
                              ) : (
                                ""
                              )}
                            </>
                          ) : null}
                        </div>
                      </>
                    ))}
                  </div>
                </>
              ) : (
                ""
              )}

              {supplierInfoId === 6 ? (
                <>
                  <div className="row mb-12">
                    <div className="col-sm-6">
                      <div className=" row">
                        <label className="col-form-label col-md-2 form-label">
                          File 1
                        </label>
                        <div className="col-md-10">
                          <Field type="hidden" name="FileId1" />
                          <FileInput
                            id="File1"
                            name="File1"
                            className="form-control form-control-sm"
                            accept="*"
                            handleChange={_handleFileChange}
                            value={fileDetails[0]?.FileName}
                          />
                          <a
                            href={
                              File1Url ? File1Url : fileDetails[0]?.FileName
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {(File1Url || fileDetails[0]?.FileName) &&
                              "Attachment"}
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className=" row">
                        <label className="col-form-label col-md-2 form-label">
                          File 2
                        </label>
                        <div className="col-md-10">
                          <Field type="hidden" name="FileId2" />
                          <FileInput
                            id="File2"
                            name="File2"
                            className="form-control form-control-sm"
                            value={fileDetails[1]?.FileName}
                            accept="*"
                            handleChange={_handleFileChange}
                          />
                          <a
                            href={
                              File2Url ? File2Url : fileDetails[1]?.FileName
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {(File2Url || fileDetails[1]?.FileName) &&
                              "Attachment"}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className=" row">
                        <label className="col-form-label col-md-2 form-label">
                          File 3
                        </label>
                        <div className="col-md-10">
                          <Field type="hidden" name="FileId3" />
                          <FileInput
                            id="File3"
                            name="File3"
                            value={fileDetails[2]?.FileName}
                            className="form-control form-control-sm"
                            accept="*"
                            handleChange={_handleFileChange}
                          />
                          <a
                            href={
                              File3Url ? File3Url : fileDetails[2]?.FileName
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {(File3Url || fileDetails[2]?.FileName) &&
                              "Attachment"}
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className=" row">
                        <label className="col-form-label col-md-2 form-label">
                          File 4
                        </label>
                        <div className="col-md-10">
                          <Field type="hidden" name="FileId4" />
                          <FileInput
                            id="File4"
                            name="File4"
                            value={fileDetails[3]?.FileName}
                            className="form-control form-control-sm"
                            accept="*"
                            handleChange={_handleFileChange}
                          />
                          <a
                            href={
                              File4Url ? File4Url : fileDetails[3]?.FileName
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {(File4Url || fileDetails[3]?.FileName) &&
                              "Attachment"}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className=" row">
                        <label className="col-form-label col-md-2 form-label">
                          File 5
                        </label>
                        <div className="col-md-10">
                          <Field type="hidden" name="FileId5" />
                          <FileInput
                            id="File5"
                            name="File5"
                            value={fileDetails[4]?.FileName}
                            className="form-control form-control-sm"
                            accept="*"
                            handleChange={_handleFileChange}
                          />
                          <a
                            href={
                              File5Url ? File5Url : fileDetails[4]?.FileName
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {(File5Url || fileDetails[4]?.FileName) &&
                              "Attachment"}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}

              <button
                type="submit"
                className="btn btn-sm btn-primary pull-right mb-3 mt-1"
                onClick={() => {
                  validateForm().then((errors) => {
                    if (Object.keys(errors).length === 0) {
                      // console.log("Form is valid");
                      return true;
                    } else {
                      // console.log("Form is invalid");
                      toastError(
                        // Object.keys(errors).length != 1
                        //   ? ALL_NECESSARY_FIELD :
                        NECESSARY_FIELD +
                          ` below tabs in ${
                            (errors.CompanyName ||
                            errors.FirstName ||
                            errors.LastName ||
                            errors.EMail ||
                            errors.PhoneNumber
                              ? "Personal Details"
                              : "") ||
                            (errors.Address1 ||
                            errors.Address2 ||
                            errors.City ||
                            errors.State ||
                            errors.Zip ||
                            errors.Country
                              ? "Address"
                              : "") ||
                            (errors.Account ||
                            errors.Openingbalance ||
                            errors.Balance
                              ? "Account Balance"
                              : "")
                          }`
                      );
                      return false;
                    }
                  });
                }}
              >
                Save
              </button>
              <Link
                onClick={previoudPage}
                className="btn btn-sm btn-dark btn-md me-1 pull-right mt-1"
              >
                Cancel
              </Link>
            </div>
          </Form>
        )}
      </Formik>

    </div>

    </div>
    


   
    </>
    
  );

  
}

export default SupplierFormData;
